import { Action } from '@ngrx/store';

import { DesignationsGridColumnName } from '../../grid/types/column.types';
import { ColumnSortModel } from '../../grid/types/sorting.types';
import { Allotment } from '../../types/allotment.types';
import {
  DesignationBreakdown,
  DesignationBreakdownPayload,
  DesignationDealInfo,
  DesignationEntryStatus,
  DesignationIssue,
  DesignationsCardTypes
} from '../../types/designation.types';

export enum DesignationActionTypes {
  LoadDesignationsTab = '[Designation Tab] Load',
  TriggerReloadDesignationsTab = '[Designation Tab] Trigger Reload',
  ReloadDesignationsTab = '[Designation Tab] Reload',
  ClearDesiData = '[Designation Allotments] Clear Designation Data',
  LoadAllotments = '[Designation Allotments] Load Allotments',
  LoadAllotmentsSuccess = '[Designation Allotments] Load Allotments Success',
  LoadAllotmentsFailure = '[Designation Allotments] Load Allotments Failure',
  UpdateSelectedAllotments = '[Designation Allotments] Update Selected Allotments',
  LoadDesignationIssues = '[Designation Issues] Load',
  LoadDesignationIssuesSuccess = '[Designation Issues] Load Success',
  LoadDesignationIssuesFailure = '[Designation Issues] Load Failure',
  LoadDesignationDealInfo = '[Designation Deal Info] Load',
  LoadDesignationDealInfoSuccess = '[Designation Deal Info] Load Deal Info Success',
  LoadDesignationDealInfoFailure = '[Designation Deal Info] Load Deal Info Failure',
  SubmitDesignationBreakdown = '[Designation breakdown] Submit',
  SubmitDesignationBreakdownSuccess = '[Designation breakdown] Submit Success',
  SubmitDesignationBreakdownFailure = '[Designation breakdown] Submit Failure',
  CompleteDesignationBreakdownSubmission = '[Designation breakdown] Complete Designation Breakdown Submission',
  UpdateDesiBreakdownFormIsDirty = '[Designation breakdown] Update Desi Breakdown Form is Dirty',
  SetDesignationBreakdownFailureError = '[Designation breakdown] Set Designation Breakdown Failure Error',
  ResetDesignationBreakdownFailureError = '[Designation breakdown] Reset Designation Breakdown Failure Error',
  OpenBreakdownErrorModal = '[Designation breakdown] Open Breakdown Error Modal',
  CloseBreakdownErrorModal = '[Designation breakdown] Close Breakdown Error Modal',
  OpenSubmissionConflictErrorModal = '[Designation breakdown] Open Submission Conflict Error Modal',
  CloseSubmissionConflictErrorModal = '[Designation breakdown] Close Submission Conflict Error Modal',
  CloseBreakdownFormConfirmModal = '[Designation breakdown] Close Breakdown Form Confirm Modal',
  LoadBreakdown = '[Designation breakdown] Load Breakdown',
  LoadBreakdownSuccess = '[Designation breakdown] Load Breakdown Success',
  LoadBreakdownFailure = '[Designation breakdown] Load Breakdown Failure',
  LoadDesiEntryStatus = '[Designation breakdown] Load Designation Entry Status',
  LoadDesiEntryStatusSuccess = '[Designation breakdown] Load Designation Entry Status Success',
  LoadDesiEntryStatusFailure = '[Designation breakdown] Load Designation Entry Status Failure',
  UpdateHasDifferentBreakdowns = '[Designation Allotments] Update Has Different Breakdowns',
  UpdateDesignationStatus = '[Designation breakdown] Update Designation Status',
  DesignationsSetCardSortModel = '[Designations] Set Card Sort Model',
  SetActiveTab = '[Designation breakdown] Set Active Tab',
  ResetActiveTab = '[Designation breakdown] Reset Active Tab',
  SaveFormattedDesignationIssues = '[Designations] Save Formatted Designation Issues',
  ExportDesignationIssues = '[Designations] Export Designation Issues'
}

export class SetActiveTab implements Action {
  public readonly type = DesignationActionTypes.SetActiveTab;

  constructor(public payload: string) {}
}

export class ResetActiveTab implements Action {
  public readonly type = DesignationActionTypes.ResetActiveTab;
}

export class LoadDesignationsTab implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationsTab;
}

export class TriggerReloadDesignationsTab implements Action {
  public readonly type = DesignationActionTypes.TriggerReloadDesignationsTab;
}

export class ReloadDesignationsTab implements Action {
  public readonly type = DesignationActionTypes.ReloadDesignationsTab;
}

export class ClearDesiData implements Action {
  public readonly type = DesignationActionTypes.ClearDesiData;
}

export class LoadAllotments implements Action {
  public readonly type = DesignationActionTypes.LoadAllotments;
}

export class LoadAllotmentsSuccess implements Action {
  public readonly type = DesignationActionTypes.LoadAllotmentsSuccess;

  constructor(public payload: Allotment[]) {}
}

export class LoadAllotmentsFailure implements Action {
  public readonly type = DesignationActionTypes.LoadAllotmentsFailure;

  constructor(public payload: string) {}
}

export class LoadDesignationIssues implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationIssues;
}

export class LoadDesignationIssuesSuccess implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationIssuesSuccess;

  constructor(public payload: DesignationIssue[]) {}
}

export class LoadDesignationIssuesFailure implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationIssuesFailure;

  constructor(public payload: string) {}
}

export class LoadDesignationDealInfo implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationDealInfo;
}

export class LoadDesignationDealInfoSuccess implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationDealInfoSuccess;

  constructor(public payload: DesignationDealInfo) {}
}

export class LoadDesignationDealInfoFailure implements Action {
  public readonly type = DesignationActionTypes.LoadDesignationDealInfoFailure;

  constructor(public payload: string) {}
}

export class UpdateSelectedAllotments implements Action {
  public readonly type = DesignationActionTypes.UpdateSelectedAllotments;

  constructor(public selectedAllotments: Allotment[]) {}
}

export class SubmitDesignationBreakdown implements Action {
  public readonly type = DesignationActionTypes.SubmitDesignationBreakdown;
  constructor(public payload: DesignationBreakdownPayload) {}
}

export class SubmitDesignationBreakdownSuccess implements Action {
  public readonly type =
    DesignationActionTypes.SubmitDesignationBreakdownSuccess;

  constructor(public payload: DesignationBreakdown[]) {}
}

export class SubmitDesignationBreakdownFailure implements Action {
  public readonly type =
    DesignationActionTypes.SubmitDesignationBreakdownFailure;

  constructor(public payload: string) {}
}

export class CompleteDesignationBreakdownSubmission implements Action {
  public readonly type =
    DesignationActionTypes.CompleteDesignationBreakdownSubmission;
}

export class SetDesignationBreakdownFailureError implements Action {
  public readonly type =
    DesignationActionTypes.SetDesignationBreakdownFailureError;

  constructor(public payload: Record<string, unknown>) {}
}

export class UpdateDesiBreakdownFormIsDirty implements Action {
  public readonly type = DesignationActionTypes.UpdateDesiBreakdownFormIsDirty;

  constructor(public isFormDirty: boolean) {}
}

export class ResetDesignationBreakdownFailureError implements Action {
  public readonly type =
    DesignationActionTypes.ResetDesignationBreakdownFailureError;
}

export class OpenBreakdownErrorModal implements Action {
  public readonly type = DesignationActionTypes.OpenBreakdownErrorModal;
}

export class CloseBreakdownErrorModal implements Action {
  public readonly type = DesignationActionTypes.CloseBreakdownErrorModal;
}

export class OpenSubmissionConflictErrorModal implements Action {
  public readonly type =
    DesignationActionTypes.OpenSubmissionConflictErrorModal;
}

export class CloseSubmissionConflictErrorModal implements Action {
  public readonly type =
    DesignationActionTypes.CloseSubmissionConflictErrorModal;
}
export class CloseBreakdownFormConfirmModal implements Action {
  public readonly type = DesignationActionTypes.CloseBreakdownFormConfirmModal;
}

export class LoadBreakdown implements Action {
  public readonly type = DesignationActionTypes.LoadBreakdown;
}

export class LoadBreakdownSuccess implements Action {
  public readonly type = DesignationActionTypes.LoadBreakdownSuccess;

  constructor(public data: DesignationBreakdown[]) {}
}

export class LoadBreakdownFailure implements Action {
  public readonly type = DesignationActionTypes.LoadBreakdownFailure;

  constructor(public payload: string) {}
}

export class LoadDesiEntryStatus implements Action {
  public readonly type = DesignationActionTypes.LoadDesiEntryStatus;

  constructor(public ignoreDisableTab: boolean) {}
}

export class LoadDesiEntryStatusSuccess implements Action {
  public readonly type = DesignationActionTypes.LoadDesiEntryStatusSuccess;

  constructor(public data: DesignationEntryStatus) {}
}

export class LoadDesiEntryStatusFailure implements Action {
  public readonly type = DesignationActionTypes.LoadDesiEntryStatusFailure;

  constructor(public payload: string) {}
}

export class UpdateHasDifferentBreakdowns implements Action {
  public readonly type = DesignationActionTypes.UpdateHasDifferentBreakdowns;

  constructor(public hasDifferentBreakdowns: boolean) {}
}

export class UpdateDesignationStatus implements Action {
  public readonly type = DesignationActionTypes.UpdateDesignationStatus;
}

export class DesignationsSetCardSortModel implements Action {
  public readonly type = DesignationActionTypes.DesignationsSetCardSortModel;
  constructor(
    public payload: {
      key: DesignationsCardTypes;
      sortModel: ColumnSortModel<DesignationsGridColumnName>[];
    }
  ) {}
}

export class SaveFormattedDesignationIssues implements Action {
  public readonly type = DesignationActionTypes.SaveFormattedDesignationIssues;

  constructor(public payload: {
    issues: DesignationIssue[],
    issueStatusType: DesignationsCardTypes
  }) { }
}

export class ExportDesignationIssues implements Action {
  public readonly type = DesignationActionTypes.ExportDesignationIssues;
}

export type DesignationActionUnion =
  | LoadDesignationsTab
  | TriggerReloadDesignationsTab
  | ReloadDesignationsTab
  | ClearDesiData
  | LoadAllotments
  | LoadAllotmentsSuccess
  | LoadAllotmentsFailure
  | UpdateSelectedAllotments
  | LoadDesignationIssues
  | LoadDesignationIssuesSuccess
  | LoadDesignationIssuesFailure
  | DesignationsSetCardSortModel
  | LoadDesignationDealInfo
  | LoadDesignationDealInfoSuccess
  | LoadDesignationDealInfoFailure
  | SubmitDesignationBreakdown
  | SubmitDesignationBreakdownSuccess
  | SubmitDesignationBreakdownFailure
  | CompleteDesignationBreakdownSubmission
  | UpdateDesiBreakdownFormIsDirty
  | SetDesignationBreakdownFailureError
  | ResetDesignationBreakdownFailureError
  | OpenBreakdownErrorModal
  | CloseBreakdownErrorModal
  | OpenSubmissionConflictErrorModal
  | CloseSubmissionConflictErrorModal
  | CloseBreakdownFormConfirmModal
  | LoadBreakdown
  | LoadBreakdownSuccess
  | LoadBreakdownFailure
  | LoadDesiEntryStatus
  | LoadDesiEntryStatusSuccess
  | LoadDesiEntryStatusFailure
  | UpdateHasDifferentBreakdowns
  | UpdateDesignationStatus
  | SetActiveTab
  | ResetActiveTab
  | SaveFormattedDesignationIssues
  | ExportDesignationIssues;
